// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document-title[data-v-1ae20725] {\n  word-break: break-all;\n}\nprogress.progress[data-v-1ae20725] {\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
